/**
 * Função auxiliar para obter o valor do CNPJ considerando letras
 * @param {string} char - Caractere alfanumérico
 * @returns {number} Valor correspondente ao caractere
 */
function getValorCNPJ(char) {
  const ascii = char.charCodeAt(0);
  // Alinha com a regra do servidor: valor = ASCII - 48
  // Números: '0'..'9' => 0..9
  // Letras maiúsculas: 'A'..'Z' (65..90) => 17..42
  // Letras minúsculas: 'a'..'z' (97..122) => 49..74
  if ((ascii >= 48 && ascii <= 57) || (ascii >= 65 && ascii <= 90) || (ascii >= 97 && ascii <= 122)) {
    return ascii - 48;
  }
  return 0; // Para caracteres não alfanuméricos
}

/**
 * Valida CNPJ alfanumérico com os 2 dígitos verificadores
 * Novo padrão: aceita letras nos primeiros 8 caracteres
 * Ex: M4.9VX.R5D/0001-35 => M49VXR5D000135 (14 caracteres)
 * 
 * @param {string} value - CNPJ a ser validado (com ou sem formatação)
 * @returns {boolean} true se válido, false caso contrário
 */
function validarCNPJ(value) {
  if (value === '') {
    return true;
  }

  // Remove caracteres não alfanuméricos
  const sCnpj = value.replace(/[^A-Za-z0-9]+/g, '');

  // Verifica se o CNPJ tem 14 caracteres (12 alfanuméricos + 2 dígitos verificadores)
  if (sCnpj.length !== 14) {
    return false;
  }

  // Elimina CNPJs inválidos conhecidos
  const cnpjsInvalidos = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
  ];

  if (cnpjsInvalidos.includes(sCnpj)) {
    return false;
  }

  // Cálculo do primeiro dígito verificador
  let iTot1 = 0;
  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]; // Pesos para o primeiro DV

  for (let I = 0; I < 12; I++) {
    const valor = getValorCNPJ(sCnpj.charAt(I));
    iTot1 += valor * pesos1[I];
  }

  let resto1 = iTot1 % 11;
  let primeiroDV = resto1 < 2 ? 0 : 11 - resto1;

  // Cálculo do segundo dígito verificador
  let iTot2 = 0;
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]; // Pesos para o segundo DV

  // Adiciona o primeiro DV ao cálculo
  for (let I = 0; I < 12; I++) {
    const valor = getValorCNPJ(sCnpj.charAt(I));
    iTot2 += valor * pesos2[I];
  }
  iTot2 += primeiroDV * pesos2[12];

  let resto2 = iTot2 % 11;
  let segundoDV = resto2 < 2 ? 0 : 11 - resto2;

  // Valida os dígitos verificadores
  return primeiroDV === parseInt(sCnpj.charAt(12)) && segundoDV === parseInt(sCnpj.charAt(13));
}

export { validarCNPJ, getValorCNPJ };